"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../icon/Upload/index.js");

var _index2 = _interopRequireDefault(_index);

var _constants = require("../constants");

var _Button = require("./Button");

var _Button2 = _interopRequireDefault(_Button);

var _context = require("./context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ButtonUpload = function ButtonUpload(props) {
  var _useButtonGroupContex = (0, _context.useButtonGroupContext)(),
      testId = _useButtonGroupContex.testId;

  return _react2.default.createElement(_Button2.default, _extends({
    id: _constants.NAMESPACES.TOOLBAR.BUTTON_UPLOAD,
    testId: testId + "__upload",
    icon: _react2.default.createElement(_index2.default, {
      size: _Button.IconSize.Heavy
    })
  }, props));
};

exports.default = ButtonUpload;